<template>
  <div class="module-list">
    <h3>
      <span>模块列表</span>
      <el-button
        type="primary"
        size="mini"
        :disabled="modules.length === 0 || modules.find(item => item.__loading) != null"
        @click="$emit('load-fields')"
      >加载字段</el-button>
    </h3>
    <ul v-if="modules.length !== 0">
      <li v-for="(item, index) in modules" :key="index" :class="{ select: currentModule === item}" @click="handleSelect(item)">
        <el-popover
          v-if="item.__loading"
          placement="top-start"
          width="200"
          trigger="click"
          content="模块字段数据智能加载中，请稍等..."
        >
          <div class="module-item" slot="reference">
            <p>{{item.moduleName}}</p>
            <i class="el-icon-delete"></i>
            <i v-show="item.__loading" class="el-icon-loading"></i>
          </div>
        </el-popover>
        <div v-else class="module-item" slot="reference">
          <p :class="{error: item.fields.length === 0 && !item.loading, warning: !images[index] || !numbers[index]}">
            <i
              v-if=" item.__failed ||
                !validateVariable(item) ||
                !validateFieldRequired(item, 'variable') ||
                !validateFieldRequired(item, 'label') ||
                !validateFieldRepeat(item, 'variable') ||
                !validateFieldRepeat(item, 'label') ||
                !validateModuleFieldRowMissing(item) ||
                !validateModuleField(item)
              "
              slot="reference"
              class="el-icon-error"
            ></i>
            <i
              v-else-if="
                !validateDataTypeMissing(item, 'IMAGE') ||
                !validateDataTypeMissing(item, 'NUMBER') ||
                !validateModuleFieldRowNotMatch(item)
              "
              class="el-icon-warning"
            ></i>
            <span>{{item.moduleName}}{{images[index]}}</span>
          </p>
          <i class="el-icon-edit" @click.stop="handleEdit(item, index)"></i>
          <i class="el-icon-delete" @click.stop="handleDelete(item, index)"></i>
          <i class="el-icon-refresh" @click="handleReload(item)"></i>
        </div>
      </li>
    </ul>
    <div v-else class="state-box">
      <div class="state-wrap">
        <p>暂无模块数据</p>
        <p>1. 在上方输入系统名称</p>
        <p>2. 点击【AI获取】按钮</p>
        <p>3. 智能加载模块数据</p>
      </div>
    </div>
    <div v-if="modules.length !== 0" class="module-foot">
      <div>
        <el-button type="primary" @click="handleCreation">新建模块</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ValidateMixin from './ValidateMixin'

export default {
  name: 'NavMenu',
  mixins: [ValidateMixin],
  props: {
    // 模块
    modules: {
      type: Array
    },
    // 当前选中模块
    currentModule: {}
  },
  data () {
    return {
      images: [],
      numbers: []
    }
  },
  methods: {
    // 处理选中
    handleSelect (item) {
      this.$emit('select', item)
    },
    // 重载
    handleReload (item) {
      this.$emit('reload', item, 5)
    },
    // 删除
    handleDelete (item, index) {
      this.$emit('delete', item, index)
    },
    // 编辑
    handleEdit (item) {
      this.$emit('edit', item)
    },
    // 创建
    handleCreation (item) {
      this.$emit('creation', item)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/style/variables";
.module-list {
  width: 220px;
  flex-shrink: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f7f7f7;
  h3 {
    padding: 5px 10px;
    font-size: 15px;
    font-weight: normal;
    border-bottom: 1px solid #e0e0e0;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  ul {
    flex-grow: 1;
    overflow-y: auto;
    position: relative;
    background-color: #fff;
    li {
      color: #333 !important;
      border-bottom: 1px dashed #eee;
      transition: all ease .15s;
      .module-item {
        font-size: 13px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 0 10px;
        cursor: default;
        p {
          display: flex;
          align-items: center;
          flex-grow: 1;
          cursor: default;
          .el-icon-error {
            color: #f56c6c!important;
            i {
              display: inline!important;
            }
          }
          .el-icon-warning {
            color: #ffc20f!important;
            i {
              display: inline!important;
            }
          }
        }
        i {
          flex-shrink: 0;
          width: 20px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          opacity: .6;
          cursor: pointer;
          &:last-of-type {
            margin-right: 0;
          }
          &:hover {
            opacity: 1;
          }
        }
      }
      &:hover {
        background-color: #ecf2fd;
      }
    }
    .select {
      color: #555;
      background-color: #dfe7fd;
      p {
        font-weight: bold;
        color: $primary-color;
      }
      &:hover {
        background-color: #dfe7fd;
        color: #555;
      }
    }
  }
  .state-box {
    width: 150px;
    margin: 0 auto;
    flex-grow: 1;
    font-size: 13px;
    font-weight: 400;
    display: flex;
    justify-content: center;
    align-items: center;
    .state-wrap {
      margin-top: -100px;
      p {
        margin: 0;
        &:first-of-type {
          color: #999;
          text-align: center;
          margin-bottom: 10px;
        }
      }
    }
  }
  .module-foot{
    width: 100%;
    flex-shrink: 1;
    background-color: white;
    div{
      height: 45px;
      border-top: 1px solid #e2e2e2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

</style>
